/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as IndexImport } from "./routes/index";
import { Route as WaitingRoomIndexImport } from "./routes/waiting-room/index";
import { Route as UpdateRequiredIndexImport } from "./routes/update-required/index";
import { Route as SettingsIndexImport } from "./routes/settings/index";
import { Route as RecommendationIndexImport } from "./routes/recommendation/index";
import { Route as PatientsIndexImport } from "./routes/patients/index";
import { Route as HomeIndexImport } from "./routes/home/index";
import { Route as GeneralTermsIndexImport } from "./routes/general-terms/index";
import { Route as CalendarIndexImport } from "./routes/calendar/index";
import { Route as AccessBlockedIndexImport } from "./routes/access-blocked/index";
import { Route as SettingsAssistImport } from "./routes/settings/assist";
import { Route as OnelivWelcomeImport } from "./routes/oneliv/welcome";
import { Route as OnelivUseTermsImport } from "./routes/oneliv/use-terms";
import { Route as OnelivTreatmentFocusImport } from "./routes/oneliv/treatment-focus";
import { Route as OnelivSocialMediaImport } from "./routes/oneliv/social-media";
import { Route as OnelivMedicalInstitutionsImport } from "./routes/oneliv/medical-institutions";
import { Route as OnelivFaqImport } from "./routes/oneliv/faq";
import { Route as OnelivExperiencesImport } from "./routes/oneliv/experiences";
import { Route as OnelivEducationalBackgroundImport } from "./routes/oneliv/educational-background";
import { Route as OnelivBasicInfoImport } from "./routes/oneliv/basic-info";
import { Route as OnelivAdditionalInfoImport } from "./routes/oneliv/additional-info";
import { Route as ExtendTimeAppointmentIdImport } from "./routes/extend-time/$appointmentId";
import { Route as AuthLogoutImport } from "./routes/auth/logout";
import { Route as AuthLoginImport } from "./routes/auth/login";
import { Route as AuthCallbackImport } from "./routes/auth/callback";
import { Route as SettingsScheduleOptionsIndexImport } from "./routes/settings/schedule-options/index";
import { Route as SettingsReservedSchedulesIndexImport } from "./routes/settings/reserved-schedules/index";
import { Route as SettingsReferralIndexImport } from "./routes/settings/referral/index";
import { Route as SettingsProfileIndexImport } from "./routes/settings/profile/index";
import { Route as SettingsPaymentsIndexImport } from "./routes/settings/payments/index";
import { Route as SettingsCommunityIndexImport } from "./routes/settings/community/index";
import { Route as SettingsBillingIndexImport } from "./routes/settings/billing/index";
import { Route as SettingsAssistIndexImport } from "./routes/settings/assist/index";
import { Route as RecommendationConfirmationIndexImport } from "./routes/recommendation/confirmation/index";
import { Route as PatientsPatientIdIndexImport } from "./routes/patients/$patientId/index";
import { Route as AppointmentCreateIndexImport } from "./routes/appointment/create/index";
import { Route as WaitingRoomFollowUpAppointmentReminderAppointmentIdImport } from "./routes/waiting-room/follow-up-appointment-reminder/$appointmentId";
import { Route as SettingsBillingDetailsImport } from "./routes/settings/billing/details";
import { Route as SettingsBillingBillingItemIdImport } from "./routes/settings/billing/$billingItemId";
import { Route as PatientsPatientIdUpdateImport } from "./routes/patients/$patientId/update";
import { Route as CalendarUnavailableSlotsCreateImport } from "./routes/calendar/unavailable-slots/create";
import { Route as AppointmentCreateSearchPatientImport } from "./routes/appointment/create/search-patient";
import { Route as AppointmentCreatePatientImport } from "./routes/appointment/create/patient";
import { Route as AppointmentCreateFlexiblePricingImport } from "./routes/appointment/create/flexible-pricing";
import { Route as AppointmentCreateAvailableOptionsImport } from "./routes/appointment/create/available-options";
import { Route as AppointmentAppointmentIdReschedulePatientImport } from "./routes/appointment/$appointmentId/reschedule-patient";
import { Route as AppointmentAppointmentIdRescheduleImport } from "./routes/appointment/$appointmentId/reschedule";
import { Route as AppointmentAppointmentIdPatientSwapSearchImport } from "./routes/appointment/$appointmentId/patient-swap-search";
import { Route as AppointmentAppointmentIdPatientSwapImport } from "./routes/appointment/$appointmentId/patient-swap";
import { Route as AppointmentAppointmentIdFlexiblePricingImport } from "./routes/appointment/$appointmentId/flexible-pricing";
import { Route as WaitingRoomCodAgendamentoSendTotemPaymentIndexImport } from "./routes/waiting-room/$codAgendamento/send-totem-payment/index";
import { Route as WaitingRoomCodAgendamentoReceiveRoomNowIndexImport } from "./routes/waiting-room/$codAgendamento/receive-room-now/index";
import { Route as WaitingRoomCodAgendamentoMenuIndexImport } from "./routes/waiting-room/$codAgendamento/menu/index";
import { Route as WaitingRoomCodAgendamentoChoosePaymentChannelIndexImport } from "./routes/waiting-room/$codAgendamento/choose-payment-channel/index";
import { Route as WaitingRoomCodAgendamentoChangeTimeIndexImport } from "./routes/waiting-room/$codAgendamento/change-time/index";
import { Route as SettingsScheduleOptionsSchedulesIndexImport } from "./routes/settings/schedule-options/schedules/index";
import { Route as SettingsScheduleOptionsAppointmentTypesIndexImport } from "./routes/settings/schedule-options/appointment-types/index";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsIndexImport } from "./routes/settings/schedule-options/appointment-receiving-options/index";
import { Route as SettingsReservedSchedulesTermsOfUseIndexImport } from "./routes/settings/reserved-schedules/terms-of-use/index";
import { Route as SettingsReservedSchedulesCreateIndexImport } from "./routes/settings/reserved-schedules/create/index";
import { Route as SettingsReservedSchedulesReservedScheduleIdIndexImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.index";
import { Route as SettingsProfileUpsertPublicPhoneIndexImport } from "./routes/settings/profile/upsert-public-phone/index";
import { Route as SettingsProfileChangePlanIndexImport } from "./routes/settings/profile/change-plan/index";
import { Route as SettingsProfileCardIndexImport } from "./routes/settings/profile/card/index";
import { Route as SettingsPaymentsTermsOfServiceIndexImport } from "./routes/settings/payments/terms-of-service/index";
import { Route as SettingsPaymentsPayablesIndexImport } from "./routes/settings/payments/payables/index";
import { Route as SettingsPaymentsPatientPaymentsIndexImport } from "./routes/settings/payments/patient-payments/index";
import { Route as SettingsPaymentsEvolutionChartsIndexImport } from "./routes/settings/payments/evolution-charts/index";
import { Route as SettingsPaymentsCreateIndexImport } from "./routes/settings/payments/create/index";
import { Route as SettingsPaymentsBankAccountIndexImport } from "./routes/settings/payments/bank-account/index";
import { Route as SettingsAssistUserTrackableLinksIndexImport } from "./routes/settings/assist/user-trackable-links/index";
import { Route as SettingsAssistUnsubscribeAssistProIndexImport } from "./routes/settings/assist/unsubscribe-assist-pro/index";
import { Route as SettingsAssistSubscribedAssistIndexImport } from "./routes/settings/assist/subscribed-assist/index";
import { Route as SettingsAssistSubscribeAssistProIndexImport } from "./routes/settings/assist/subscribe-assist-pro/index";
import { Route as SettingsAssistSubscribeAssistProLegacyIndexImport } from "./routes/settings/assist/subscribe-assist-pro-legacy/index";
import { Route as SettingsAssistSecretaryDetailsIndexImport } from "./routes/settings/assist/secretary-details/index";
import { Route as SettingsAssistRescuedAppointmentOverviewIndexImport } from "./routes/settings/assist/rescued-appointment-overview/index";
import { Route as SettingsAssistFollowUpAppointmentReminderIndexImport } from "./routes/settings/assist/follow-up-appointment-reminder/index";
import { Route as SettingsAssistFeatureSettingsIndexImport } from "./routes/settings/assist/feature-settings/index";
import { Route as SettingsAssistCustomerSiteOverviewIndexImport } from "./routes/settings/assist/customer-site-overview/index";
import { Route as SettingsAssistCustomerContactOverviewIndexImport } from "./routes/settings/assist/customer-contact-overview/index";
import { Route as SettingsAssistCustomerAppointmentOverviewIndexImport } from "./routes/settings/assist/customer-appointment-overview/index";
import { Route as SettingsAssistAssistProAcceptanceIndexImport } from "./routes/settings/assist/assist-pro-acceptance/index";
import { Route as WaitingRoomFollowUpAppointmentReminderPatientPatientIdImport } from "./routes/waiting-room/follow-up-appointment-reminder/patient/$patientId";
import { Route as SettingsScheduleOptionsSchedulesCreateImport } from "./routes/settings/schedule-options/schedules/create";
import { Route as SettingsScheduleOptionsSchedulesScheduleIdImport } from "./routes/settings/schedule-options/schedules/$scheduleId";
import { Route as SettingsScheduleOptionsAppointmentTypesCreateImport } from "./routes/settings/schedule-options/appointment-types/create";
import { Route as SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdImport } from "./routes/settings/schedule-options/appointment-types/$appointmentTypeId";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsCreateImport } from "./routes/settings/schedule-options/appointment-receiving-options/create";
import { Route as SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdImport } from "./routes/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId";
import { Route as SettingsReservedSchedulesCreateStartingDayImport } from "./routes/settings/reserved-schedules/create/starting-day";
import { Route as SettingsReservedSchedulesCreateSlotsImport } from "./routes/settings/reserved-schedules/create/slots";
import { Route as SettingsReservedSchedulesCreateConfirmImport } from "./routes/settings/reserved-schedules/create/confirm";
import { Route as SettingsReservedSchedulesReservedScheduleIdCancelImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.cancel";
import { Route as SettingsProfileCardCreateImport } from "./routes/settings/profile/card/create";
import { Route as SettingsPaymentsPayablesAboutImport } from "./routes/settings/payments/payables/about";
import { Route as SettingsPaymentsPatientPaymentsRefundReceiptImport } from "./routes/settings/payments/patient-payments/refund-receipt";
import { Route as SettingsPaymentsPatientPaymentsRefundImport } from "./routes/settings/payments/patient-payments/refund";
import { Route as SettingsPaymentsPatientPaymentsDetailsImport } from "./routes/settings/payments/patient-payments/details";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentsImport } from "./routes/settings/payments/patient-payments/about-payments";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentDetailsImport } from "./routes/settings/payments/patient-payments/about-payment-details";
import { Route as SettingsPaymentsPatientPaymentsAboutPaymentAnticipationImport } from "./routes/settings/payments/patient-payments/about-payment-anticipation";
import { Route as SettingsPaymentsCreateConfirmationImport } from "./routes/settings/payments/create/confirmation";
import { Route as SettingsPaymentsBankAccountUpdateImport } from "./routes/settings/payments/bank-account/update";
import { Route as SettingsPaymentsBankAccountChangeBankAccountOrOwnershipImport } from "./routes/settings/payments/bank-account/change-bank-account-or-ownership";
import { Route as SettingsAssistSecretaryDetailsRestrictionsImport } from "./routes/settings/assist/secretary-details/restrictions";
import { Route as SettingsAssistSecretaryDetailsProfessionalInfosImport } from "./routes/settings/assist/secretary-details/professional-infos";
import { Route as SettingsAssistSecretaryDetailsFaqImport } from "./routes/settings/assist/secretary-details/faq";
import { Route as SettingsAssistSecretaryDetailsAppointmentInfosImport } from "./routes/settings/assist/secretary-details/appointment-infos";
import { Route as WaitingRoomCodAgendamentoChangeTimeConfirmIndexImport } from "./routes/waiting-room/$codAgendamento/change-time/confirm/index";
import { Route as SettingsAssistUserTrackableLinksCreateIndexImport } from "./routes/settings/assist/user-trackable-links/create/index";
import { Route as SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexImport } from "./routes/settings/assist/user-trackable-links/$userTrackableLinkId/index";
import { Route as SettingsAssistUnsubscribeAssistProUpsertPhoneIndexImport } from "./routes/settings/assist/unsubscribe-assist-pro/upsert-phone/index";
import { Route as SettingsAssistSubscribeAssistProConfirmIndexImport } from "./routes/settings/assist/subscribe-assist-pro/confirm/index";
import { Route as SettingsAssistFollowUpAppointmentReminderPatientsIndexImport } from "./routes/settings/assist/follow-up-appointment-reminder/patients/index";
import { Route as SettingsAssistCustomerContactOverviewStoriesFeedIndexImport } from "./routes/settings/assist/customer-contact-overview/stories-feed/index";
import { Route as SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelImport } from "./routes/settings/reserved-schedules/$reservedScheduleId.$nextReserveId.cancel";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterStatusImport } from "./routes/settings/payments/patient-payments/filters/filter-status";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsImport } from "./routes/settings/payments/patient-payments/filters/filter-payment-methods";
import { Route as SettingsPaymentsPatientPaymentsFiltersFilterOriginsImport } from "./routes/settings/payments/patient-payments/filters/filter-origins";
import { Route as SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusImport } from "./routes/settings/payments/patient-payments/$guid/change-online-payment-status";
import { Route as SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexImport } from "./routes/settings/assist/user-trackable-links/$userTrackableLinkId/report/index";

// Create/Update Routes

const IndexRoute = IndexImport.update({
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const WaitingRoomIndexRoute = WaitingRoomIndexImport.update({
  path: "/waiting-room/",
  getParentRoute: () => rootRoute,
} as any);

const UpdateRequiredIndexRoute = UpdateRequiredIndexImport.update({
  path: "/update-required/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsIndexRoute = SettingsIndexImport.update({
  path: "/settings/",
  getParentRoute: () => rootRoute,
} as any);

const RecommendationIndexRoute = RecommendationIndexImport.update({
  path: "/recommendation/",
  getParentRoute: () => rootRoute,
} as any);

const PatientsIndexRoute = PatientsIndexImport.update({
  path: "/patients/",
  getParentRoute: () => rootRoute,
} as any);

const HomeIndexRoute = HomeIndexImport.update({
  path: "/home/",
  getParentRoute: () => rootRoute,
} as any);

const GeneralTermsIndexRoute = GeneralTermsIndexImport.update({
  path: "/general-terms/",
  getParentRoute: () => rootRoute,
} as any);

const CalendarIndexRoute = CalendarIndexImport.update({
  path: "/calendar/",
  getParentRoute: () => rootRoute,
} as any);

const AccessBlockedIndexRoute = AccessBlockedIndexImport.update({
  path: "/access-blocked/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsAssistRoute = SettingsAssistImport.update({
  path: "/settings/assist",
  getParentRoute: () => rootRoute,
} as any);

const OnelivWelcomeRoute = OnelivWelcomeImport.update({
  path: "/oneliv/welcome",
  getParentRoute: () => rootRoute,
} as any);

const OnelivUseTermsRoute = OnelivUseTermsImport.update({
  path: "/oneliv/use-terms",
  getParentRoute: () => rootRoute,
} as any);

const OnelivTreatmentFocusRoute = OnelivTreatmentFocusImport.update({
  path: "/oneliv/treatment-focus",
  getParentRoute: () => rootRoute,
} as any);

const OnelivSocialMediaRoute = OnelivSocialMediaImport.update({
  path: "/oneliv/social-media",
  getParentRoute: () => rootRoute,
} as any);

const OnelivMedicalInstitutionsRoute = OnelivMedicalInstitutionsImport.update({
  path: "/oneliv/medical-institutions",
  getParentRoute: () => rootRoute,
} as any);

const OnelivFaqRoute = OnelivFaqImport.update({
  path: "/oneliv/faq",
  getParentRoute: () => rootRoute,
} as any);

const OnelivExperiencesRoute = OnelivExperiencesImport.update({
  path: "/oneliv/experiences",
  getParentRoute: () => rootRoute,
} as any);

const OnelivEducationalBackgroundRoute =
  OnelivEducationalBackgroundImport.update({
    path: "/oneliv/educational-background",
    getParentRoute: () => rootRoute,
  } as any);

const OnelivBasicInfoRoute = OnelivBasicInfoImport.update({
  path: "/oneliv/basic-info",
  getParentRoute: () => rootRoute,
} as any);

const OnelivAdditionalInfoRoute = OnelivAdditionalInfoImport.update({
  path: "/oneliv/additional-info",
  getParentRoute: () => rootRoute,
} as any);

const ExtendTimeAppointmentIdRoute = ExtendTimeAppointmentIdImport.update({
  path: "/extend-time/$appointmentId",
  getParentRoute: () => rootRoute,
} as any);

const AuthLogoutRoute = AuthLogoutImport.update({
  path: "/auth/logout",
  getParentRoute: () => rootRoute,
} as any);

const AuthLoginRoute = AuthLoginImport.update({
  path: "/auth/login",
  getParentRoute: () => rootRoute,
} as any);

const AuthCallbackRoute = AuthCallbackImport.update({
  path: "/auth/callback",
  getParentRoute: () => rootRoute,
} as any);

const SettingsScheduleOptionsIndexRoute =
  SettingsScheduleOptionsIndexImport.update({
    path: "/settings/schedule-options/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesIndexRoute =
  SettingsReservedSchedulesIndexImport.update({
    path: "/settings/reserved-schedules/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReferralIndexRoute = SettingsReferralIndexImport.update({
  path: "/settings/referral/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsProfileIndexRoute = SettingsProfileIndexImport.update({
  path: "/settings/profile/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsPaymentsIndexRoute = SettingsPaymentsIndexImport.update({
  path: "/settings/payments/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsCommunityIndexRoute = SettingsCommunityIndexImport.update({
  path: "/settings/community/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsBillingIndexRoute = SettingsBillingIndexImport.update({
  path: "/settings/billing/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsAssistIndexRoute = SettingsAssistIndexImport.update({
  path: "/",
  getParentRoute: () => SettingsAssistRoute,
} as any);

const RecommendationConfirmationIndexRoute =
  RecommendationConfirmationIndexImport.update({
    path: "/recommendation/confirmation/",
    getParentRoute: () => rootRoute,
  } as any);

const PatientsPatientIdIndexRoute = PatientsPatientIdIndexImport.update({
  path: "/patients/$patientId/",
  getParentRoute: () => rootRoute,
} as any);

const AppointmentCreateIndexRoute = AppointmentCreateIndexImport.update({
  path: "/appointment/create/",
  getParentRoute: () => rootRoute,
} as any);

const WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute =
  WaitingRoomFollowUpAppointmentReminderAppointmentIdImport.update({
    path: "/waiting-room/follow-up-appointment-reminder/$appointmentId",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsBillingDetailsRoute = SettingsBillingDetailsImport.update({
  path: "/settings/billing/details",
  getParentRoute: () => rootRoute,
} as any);

const SettingsBillingBillingItemIdRoute =
  SettingsBillingBillingItemIdImport.update({
    path: "/settings/billing/$billingItemId",
    getParentRoute: () => rootRoute,
  } as any);

const PatientsPatientIdUpdateRoute = PatientsPatientIdUpdateImport.update({
  path: "/patients/$patientId/update",
  getParentRoute: () => rootRoute,
} as any);

const CalendarUnavailableSlotsCreateRoute =
  CalendarUnavailableSlotsCreateImport.update({
    path: "/calendar/unavailable-slots/create",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentCreateSearchPatientRoute =
  AppointmentCreateSearchPatientImport.update({
    path: "/appointment/create/search-patient",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentCreatePatientRoute = AppointmentCreatePatientImport.update({
  path: "/appointment/create/patient",
  getParentRoute: () => rootRoute,
} as any);

const AppointmentCreateFlexiblePricingRoute =
  AppointmentCreateFlexiblePricingImport.update({
    path: "/appointment/create/flexible-pricing",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentCreateAvailableOptionsRoute =
  AppointmentCreateAvailableOptionsImport.update({
    path: "/appointment/create/available-options",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentAppointmentIdReschedulePatientRoute =
  AppointmentAppointmentIdReschedulePatientImport.update({
    path: "/appointment/$appointmentId/reschedule-patient",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentAppointmentIdRescheduleRoute =
  AppointmentAppointmentIdRescheduleImport.update({
    path: "/appointment/$appointmentId/reschedule",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentAppointmentIdPatientSwapSearchRoute =
  AppointmentAppointmentIdPatientSwapSearchImport.update({
    path: "/appointment/$appointmentId/patient-swap-search",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentAppointmentIdPatientSwapRoute =
  AppointmentAppointmentIdPatientSwapImport.update({
    path: "/appointment/$appointmentId/patient-swap",
    getParentRoute: () => rootRoute,
  } as any);

const AppointmentAppointmentIdFlexiblePricingRoute =
  AppointmentAppointmentIdFlexiblePricingImport.update({
    path: "/appointment/$appointmentId/flexible-pricing",
    getParentRoute: () => rootRoute,
  } as any);

const WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute =
  WaitingRoomCodAgendamentoSendTotemPaymentIndexImport.update({
    path: "/waiting-room/$codAgendamento/send-totem-payment/",
    getParentRoute: () => rootRoute,
  } as any);

const WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute =
  WaitingRoomCodAgendamentoReceiveRoomNowIndexImport.update({
    path: "/waiting-room/$codAgendamento/receive-room-now/",
    getParentRoute: () => rootRoute,
  } as any);

const WaitingRoomCodAgendamentoMenuIndexRoute =
  WaitingRoomCodAgendamentoMenuIndexImport.update({
    path: "/waiting-room/$codAgendamento/menu/",
    getParentRoute: () => rootRoute,
  } as any);

const WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute =
  WaitingRoomCodAgendamentoChoosePaymentChannelIndexImport.update({
    path: "/waiting-room/$codAgendamento/choose-payment-channel/",
    getParentRoute: () => rootRoute,
  } as any);

const WaitingRoomCodAgendamentoChangeTimeIndexRoute =
  WaitingRoomCodAgendamentoChangeTimeIndexImport.update({
    path: "/waiting-room/$codAgendamento/change-time/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsSchedulesIndexRoute =
  SettingsScheduleOptionsSchedulesIndexImport.update({
    path: "/settings/schedule-options/schedules/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentTypesIndexRoute =
  SettingsScheduleOptionsAppointmentTypesIndexImport.update({
    path: "/settings/schedule-options/appointment-types/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsIndexImport.update({
    path: "/settings/schedule-options/appointment-receiving-options/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesTermsOfUseIndexRoute =
  SettingsReservedSchedulesTermsOfUseIndexImport.update({
    path: "/settings/reserved-schedules/terms-of-use/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesCreateIndexRoute =
  SettingsReservedSchedulesCreateIndexImport.update({
    path: "/settings/reserved-schedules/create/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesReservedScheduleIdIndexRoute =
  SettingsReservedSchedulesReservedScheduleIdIndexImport.update({
    path: "/settings/reserved-schedules/$reservedScheduleId/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsProfileUpsertPublicPhoneIndexRoute =
  SettingsProfileUpsertPublicPhoneIndexImport.update({
    path: "/settings/profile/upsert-public-phone/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsProfileChangePlanIndexRoute =
  SettingsProfileChangePlanIndexImport.update({
    path: "/settings/profile/change-plan/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsProfileCardIndexRoute = SettingsProfileCardIndexImport.update({
  path: "/settings/profile/card/",
  getParentRoute: () => rootRoute,
} as any);

const SettingsPaymentsTermsOfServiceIndexRoute =
  SettingsPaymentsTermsOfServiceIndexImport.update({
    path: "/settings/payments/terms-of-service/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPayablesIndexRoute =
  SettingsPaymentsPayablesIndexImport.update({
    path: "/settings/payments/payables/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsIndexRoute =
  SettingsPaymentsPatientPaymentsIndexImport.update({
    path: "/settings/payments/patient-payments/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsEvolutionChartsIndexRoute =
  SettingsPaymentsEvolutionChartsIndexImport.update({
    path: "/settings/payments/evolution-charts/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsCreateIndexRoute =
  SettingsPaymentsCreateIndexImport.update({
    path: "/settings/payments/create/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsBankAccountIndexRoute =
  SettingsPaymentsBankAccountIndexImport.update({
    path: "/settings/payments/bank-account/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsAssistUserTrackableLinksIndexRoute =
  SettingsAssistUserTrackableLinksIndexImport.update({
    path: "/user-trackable-links/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistUnsubscribeAssistProIndexRoute =
  SettingsAssistUnsubscribeAssistProIndexImport.update({
    path: "/unsubscribe-assist-pro/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSubscribedAssistIndexRoute =
  SettingsAssistSubscribedAssistIndexImport.update({
    path: "/subscribed-assist/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSubscribeAssistProIndexRoute =
  SettingsAssistSubscribeAssistProIndexImport.update({
    path: "/subscribe-assist-pro/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSubscribeAssistProLegacyIndexRoute =
  SettingsAssistSubscribeAssistProLegacyIndexImport.update({
    path: "/subscribe-assist-pro-legacy/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSecretaryDetailsIndexRoute =
  SettingsAssistSecretaryDetailsIndexImport.update({
    path: "/secretary-details/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistRescuedAppointmentOverviewIndexRoute =
  SettingsAssistRescuedAppointmentOverviewIndexImport.update({
    path: "/rescued-appointment-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistFollowUpAppointmentReminderIndexRoute =
  SettingsAssistFollowUpAppointmentReminderIndexImport.update({
    path: "/follow-up-appointment-reminder/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistFeatureSettingsIndexRoute =
  SettingsAssistFeatureSettingsIndexImport.update({
    path: "/feature-settings/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistCustomerSiteOverviewIndexRoute =
  SettingsAssistCustomerSiteOverviewIndexImport.update({
    path: "/customer-site-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistCustomerContactOverviewIndexRoute =
  SettingsAssistCustomerContactOverviewIndexImport.update({
    path: "/customer-contact-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistCustomerAppointmentOverviewIndexRoute =
  SettingsAssistCustomerAppointmentOverviewIndexImport.update({
    path: "/customer-appointment-overview/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistAssistProAcceptanceIndexRoute =
  SettingsAssistAssistProAcceptanceIndexImport.update({
    path: "/assist-pro-acceptance/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute =
  WaitingRoomFollowUpAppointmentReminderPatientPatientIdImport.update({
    path: "/waiting-room/follow-up-appointment-reminder/patient/$patientId",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsSchedulesCreateRoute =
  SettingsScheduleOptionsSchedulesCreateImport.update({
    path: "/settings/schedule-options/schedules/create",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsSchedulesScheduleIdRoute =
  SettingsScheduleOptionsSchedulesScheduleIdImport.update({
    path: "/settings/schedule-options/schedules/$scheduleId",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentTypesCreateRoute =
  SettingsScheduleOptionsAppointmentTypesCreateImport.update({
    path: "/settings/schedule-options/appointment-types/create",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoute =
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdImport.update({
    path: "/settings/schedule-options/appointment-types/$appointmentTypeId",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentReceivingOptionsCreateRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateImport.update({
    path: "/settings/schedule-options/appointment-receiving-options/create",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdRoute =
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdImport.update(
    {
      path: "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId",
      getParentRoute: () => rootRoute,
    } as any,
  );

const SettingsReservedSchedulesCreateStartingDayRoute =
  SettingsReservedSchedulesCreateStartingDayImport.update({
    path: "/settings/reserved-schedules/create/starting-day",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesCreateSlotsRoute =
  SettingsReservedSchedulesCreateSlotsImport.update({
    path: "/settings/reserved-schedules/create/slots",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesCreateConfirmRoute =
  SettingsReservedSchedulesCreateConfirmImport.update({
    path: "/settings/reserved-schedules/create/confirm",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsReservedSchedulesReservedScheduleIdCancelRoute =
  SettingsReservedSchedulesReservedScheduleIdCancelImport.update({
    path: "/settings/reserved-schedules/$reservedScheduleId/cancel",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsProfileCardCreateRoute = SettingsProfileCardCreateImport.update({
  path: "/settings/profile/card/create",
  getParentRoute: () => rootRoute,
} as any);

const SettingsPaymentsPayablesAboutRoute =
  SettingsPaymentsPayablesAboutImport.update({
    path: "/settings/payments/payables/about",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsRefundReceiptRoute =
  SettingsPaymentsPatientPaymentsRefundReceiptImport.update({
    path: "/settings/payments/patient-payments/refund-receipt",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsRefundRoute =
  SettingsPaymentsPatientPaymentsRefundImport.update({
    path: "/settings/payments/patient-payments/refund",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsDetailsRoute =
  SettingsPaymentsPatientPaymentsDetailsImport.update({
    path: "/settings/payments/patient-payments/details",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsAboutPaymentsRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentsImport.update({
    path: "/settings/payments/patient-payments/about-payments",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentDetailsImport.update({
    path: "/settings/payments/patient-payments/about-payment-details",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute =
  SettingsPaymentsPatientPaymentsAboutPaymentAnticipationImport.update({
    path: "/settings/payments/patient-payments/about-payment-anticipation",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsCreateConfirmationRoute =
  SettingsPaymentsCreateConfirmationImport.update({
    path: "/settings/payments/create/confirmation",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsBankAccountUpdateRoute =
  SettingsPaymentsBankAccountUpdateImport.update({
    path: "/settings/payments/bank-account/update",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute =
  SettingsPaymentsBankAccountChangeBankAccountOrOwnershipImport.update({
    path: "/settings/payments/bank-account/change-bank-account-or-ownership",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsAssistSecretaryDetailsRestrictionsRoute =
  SettingsAssistSecretaryDetailsRestrictionsImport.update({
    path: "/secretary-details/restrictions",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSecretaryDetailsProfessionalInfosRoute =
  SettingsAssistSecretaryDetailsProfessionalInfosImport.update({
    path: "/secretary-details/professional-infos",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSecretaryDetailsFaqRoute =
  SettingsAssistSecretaryDetailsFaqImport.update({
    path: "/secretary-details/faq",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSecretaryDetailsAppointmentInfosRoute =
  SettingsAssistSecretaryDetailsAppointmentInfosImport.update({
    path: "/secretary-details/appointment-infos",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute =
  WaitingRoomCodAgendamentoChangeTimeConfirmIndexImport.update({
    path: "/waiting-room/$codAgendamento/change-time/confirm/",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsAssistUserTrackableLinksCreateIndexRoute =
  SettingsAssistUserTrackableLinksCreateIndexImport.update({
    path: "/user-trackable-links/create/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute =
  SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexImport.update({
    path: "/user-trackable-links/$userTrackableLinkId/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute =
  SettingsAssistUnsubscribeAssistProUpsertPhoneIndexImport.update({
    path: "/unsubscribe-assist-pro/upsert-phone/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistSubscribeAssistProConfirmIndexRoute =
  SettingsAssistSubscribeAssistProConfirmIndexImport.update({
    path: "/subscribe-assist-pro/confirm/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute =
  SettingsAssistFollowUpAppointmentReminderPatientsIndexImport.update({
    path: "/follow-up-appointment-reminder/patients/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute =
  SettingsAssistCustomerContactOverviewStoriesFeedIndexImport.update({
    path: "/customer-contact-overview/stories-feed/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

const SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute =
  SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelImport.update({
    path: "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterStatusImport.update({
    path: "/settings/payments/patient-payments/filters/filter-status",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsImport.update({
    path: "/settings/payments/patient-payments/filters/filter-payment-methods",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute =
  SettingsPaymentsPatientPaymentsFiltersFilterOriginsImport.update({
    path: "/settings/payments/patient-payments/filters/filter-origins",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute =
  SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusImport.update({
    path: "/settings/payments/patient-payments/$guid/change-online-payment-status",
    getParentRoute: () => rootRoute,
  } as any);

const SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute =
  SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexImport.update({
    path: "/user-trackable-links/$userTrackableLinkId/report/",
    getParentRoute: () => SettingsAssistRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/auth/callback": {
      preLoaderRoute: typeof AuthCallbackImport;
      parentRoute: typeof rootRoute;
    };
    "/auth/login": {
      preLoaderRoute: typeof AuthLoginImport;
      parentRoute: typeof rootRoute;
    };
    "/auth/logout": {
      preLoaderRoute: typeof AuthLogoutImport;
      parentRoute: typeof rootRoute;
    };
    "/extend-time/$appointmentId": {
      preLoaderRoute: typeof ExtendTimeAppointmentIdImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/additional-info": {
      preLoaderRoute: typeof OnelivAdditionalInfoImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/basic-info": {
      preLoaderRoute: typeof OnelivBasicInfoImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/educational-background": {
      preLoaderRoute: typeof OnelivEducationalBackgroundImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/experiences": {
      preLoaderRoute: typeof OnelivExperiencesImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/faq": {
      preLoaderRoute: typeof OnelivFaqImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/medical-institutions": {
      preLoaderRoute: typeof OnelivMedicalInstitutionsImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/social-media": {
      preLoaderRoute: typeof OnelivSocialMediaImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/treatment-focus": {
      preLoaderRoute: typeof OnelivTreatmentFocusImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/use-terms": {
      preLoaderRoute: typeof OnelivUseTermsImport;
      parentRoute: typeof rootRoute;
    };
    "/oneliv/welcome": {
      preLoaderRoute: typeof OnelivWelcomeImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist": {
      preLoaderRoute: typeof SettingsAssistImport;
      parentRoute: typeof rootRoute;
    };
    "/access-blocked/": {
      preLoaderRoute: typeof AccessBlockedIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/calendar/": {
      preLoaderRoute: typeof CalendarIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/general-terms/": {
      preLoaderRoute: typeof GeneralTermsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/home/": {
      preLoaderRoute: typeof HomeIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/patients/": {
      preLoaderRoute: typeof PatientsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/recommendation/": {
      preLoaderRoute: typeof RecommendationIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/": {
      preLoaderRoute: typeof SettingsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/update-required/": {
      preLoaderRoute: typeof UpdateRequiredIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/": {
      preLoaderRoute: typeof WaitingRoomIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/$appointmentId/flexible-pricing": {
      preLoaderRoute: typeof AppointmentAppointmentIdFlexiblePricingImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/$appointmentId/patient-swap": {
      preLoaderRoute: typeof AppointmentAppointmentIdPatientSwapImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/$appointmentId/patient-swap-search": {
      preLoaderRoute: typeof AppointmentAppointmentIdPatientSwapSearchImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/$appointmentId/reschedule": {
      preLoaderRoute: typeof AppointmentAppointmentIdRescheduleImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/$appointmentId/reschedule-patient": {
      preLoaderRoute: typeof AppointmentAppointmentIdReschedulePatientImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/create/available-options": {
      preLoaderRoute: typeof AppointmentCreateAvailableOptionsImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/create/flexible-pricing": {
      preLoaderRoute: typeof AppointmentCreateFlexiblePricingImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/create/patient": {
      preLoaderRoute: typeof AppointmentCreatePatientImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/create/search-patient": {
      preLoaderRoute: typeof AppointmentCreateSearchPatientImport;
      parentRoute: typeof rootRoute;
    };
    "/calendar/unavailable-slots/create": {
      preLoaderRoute: typeof CalendarUnavailableSlotsCreateImport;
      parentRoute: typeof rootRoute;
    };
    "/patients/$patientId/update": {
      preLoaderRoute: typeof PatientsPatientIdUpdateImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/billing/$billingItemId": {
      preLoaderRoute: typeof SettingsBillingBillingItemIdImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/billing/details": {
      preLoaderRoute: typeof SettingsBillingDetailsImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/follow-up-appointment-reminder/$appointmentId": {
      preLoaderRoute: typeof WaitingRoomFollowUpAppointmentReminderAppointmentIdImport;
      parentRoute: typeof rootRoute;
    };
    "/appointment/create/": {
      preLoaderRoute: typeof AppointmentCreateIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/patients/$patientId/": {
      preLoaderRoute: typeof PatientsPatientIdIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/recommendation/confirmation/": {
      preLoaderRoute: typeof RecommendationConfirmationIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist/": {
      preLoaderRoute: typeof SettingsAssistIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/billing/": {
      preLoaderRoute: typeof SettingsBillingIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/community/": {
      preLoaderRoute: typeof SettingsCommunityIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/": {
      preLoaderRoute: typeof SettingsPaymentsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/profile/": {
      preLoaderRoute: typeof SettingsProfileIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/referral/": {
      preLoaderRoute: typeof SettingsReferralIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/": {
      preLoaderRoute: typeof SettingsReservedSchedulesIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/": {
      preLoaderRoute: typeof SettingsScheduleOptionsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist/secretary-details/appointment-infos": {
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsAppointmentInfosImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/secretary-details/faq": {
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsFaqImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/secretary-details/professional-infos": {
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsProfessionalInfosImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/secretary-details/restrictions": {
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsRestrictionsImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/payments/bank-account/change-bank-account-or-ownership": {
      preLoaderRoute: typeof SettingsPaymentsBankAccountChangeBankAccountOrOwnershipImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/bank-account/update": {
      preLoaderRoute: typeof SettingsPaymentsBankAccountUpdateImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/create/confirmation": {
      preLoaderRoute: typeof SettingsPaymentsCreateConfirmationImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/about-payment-anticipation": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentAnticipationImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/about-payment-details": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentDetailsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/about-payments": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsAboutPaymentsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/details": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsDetailsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/refund": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsRefundImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/refund-receipt": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsRefundReceiptImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/payables/about": {
      preLoaderRoute: typeof SettingsPaymentsPayablesAboutImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/profile/card/create": {
      preLoaderRoute: typeof SettingsProfileCardCreateImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/$reservedScheduleId/cancel": {
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdCancelImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/create/confirm": {
      preLoaderRoute: typeof SettingsReservedSchedulesCreateConfirmImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/create/slots": {
      preLoaderRoute: typeof SettingsReservedSchedulesCreateSlotsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/create/starting-day": {
      preLoaderRoute: typeof SettingsReservedSchedulesCreateStartingDayImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-receiving-options/$appointmentReceivingOptionId": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-receiving-options/create": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsCreateImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-types/$appointmentTypeId": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-types/create": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesCreateImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/schedules/$scheduleId": {
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesScheduleIdImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/schedules/create": {
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesCreateImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/follow-up-appointment-reminder/patient/$patientId": {
      preLoaderRoute: typeof WaitingRoomFollowUpAppointmentReminderPatientPatientIdImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist/assist-pro-acceptance/": {
      preLoaderRoute: typeof SettingsAssistAssistProAcceptanceIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/customer-appointment-overview/": {
      preLoaderRoute: typeof SettingsAssistCustomerAppointmentOverviewIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/customer-contact-overview/": {
      preLoaderRoute: typeof SettingsAssistCustomerContactOverviewIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/customer-site-overview/": {
      preLoaderRoute: typeof SettingsAssistCustomerSiteOverviewIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/feature-settings/": {
      preLoaderRoute: typeof SettingsAssistFeatureSettingsIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/follow-up-appointment-reminder/": {
      preLoaderRoute: typeof SettingsAssistFollowUpAppointmentReminderIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/rescued-appointment-overview/": {
      preLoaderRoute: typeof SettingsAssistRescuedAppointmentOverviewIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/secretary-details/": {
      preLoaderRoute: typeof SettingsAssistSecretaryDetailsIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/subscribe-assist-pro-legacy/": {
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProLegacyIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/subscribe-assist-pro/": {
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/subscribed-assist/": {
      preLoaderRoute: typeof SettingsAssistSubscribedAssistIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/unsubscribe-assist-pro/": {
      preLoaderRoute: typeof SettingsAssistUnsubscribeAssistProIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/user-trackable-links/": {
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/payments/bank-account/": {
      preLoaderRoute: typeof SettingsPaymentsBankAccountIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/create/": {
      preLoaderRoute: typeof SettingsPaymentsCreateIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/evolution-charts/": {
      preLoaderRoute: typeof SettingsPaymentsEvolutionChartsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/payables/": {
      preLoaderRoute: typeof SettingsPaymentsPayablesIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/terms-of-service/": {
      preLoaderRoute: typeof SettingsPaymentsTermsOfServiceIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/profile/card/": {
      preLoaderRoute: typeof SettingsProfileCardIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/profile/change-plan/": {
      preLoaderRoute: typeof SettingsProfileChangePlanIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/profile/upsert-public-phone/": {
      preLoaderRoute: typeof SettingsProfileUpsertPublicPhoneIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/$reservedScheduleId/": {
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/create/": {
      preLoaderRoute: typeof SettingsReservedSchedulesCreateIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/terms-of-use/": {
      preLoaderRoute: typeof SettingsReservedSchedulesTermsOfUseIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-receiving-options/": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentReceivingOptionsIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/appointment-types/": {
      preLoaderRoute: typeof SettingsScheduleOptionsAppointmentTypesIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/schedule-options/schedules/": {
      preLoaderRoute: typeof SettingsScheduleOptionsSchedulesIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/$codAgendamento/change-time/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChangeTimeIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/$codAgendamento/choose-payment-channel/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChoosePaymentChannelIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/$codAgendamento/menu/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoMenuIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/$codAgendamento/receive-room-now/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoReceiveRoomNowIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/waiting-room/$codAgendamento/send-totem-payment/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoSendTotemPaymentIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/$guid/change-online-payment-status": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/filters/filter-origins": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterOriginsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/filters/filter-payment-methods": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/payments/patient-payments/filters/filter-status": {
      preLoaderRoute: typeof SettingsPaymentsPatientPaymentsFiltersFilterStatusImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/reserved-schedules/$reservedScheduleId/$nextReserveId/cancel": {
      preLoaderRoute: typeof SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist/customer-contact-overview/stories-feed/": {
      preLoaderRoute: typeof SettingsAssistCustomerContactOverviewStoriesFeedIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/follow-up-appointment-reminder/patients/": {
      preLoaderRoute: typeof SettingsAssistFollowUpAppointmentReminderPatientsIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/subscribe-assist-pro/confirm/": {
      preLoaderRoute: typeof SettingsAssistSubscribeAssistProConfirmIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/unsubscribe-assist-pro/upsert-phone/": {
      preLoaderRoute: typeof SettingsAssistUnsubscribeAssistProUpsertPhoneIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/user-trackable-links/$userTrackableLinkId/": {
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/settings/assist/user-trackable-links/create/": {
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksCreateIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
    "/waiting-room/$codAgendamento/change-time/confirm/": {
      preLoaderRoute: typeof WaitingRoomCodAgendamentoChangeTimeConfirmIndexImport;
      parentRoute: typeof rootRoute;
    };
    "/settings/assist/user-trackable-links/$userTrackableLinkId/report/": {
      preLoaderRoute: typeof SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexImport;
      parentRoute: typeof SettingsAssistImport;
    };
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthCallbackRoute,
  AuthLoginRoute,
  AuthLogoutRoute,
  ExtendTimeAppointmentIdRoute,
  OnelivAdditionalInfoRoute,
  OnelivBasicInfoRoute,
  OnelivEducationalBackgroundRoute,
  OnelivExperiencesRoute,
  OnelivFaqRoute,
  OnelivMedicalInstitutionsRoute,
  OnelivSocialMediaRoute,
  OnelivTreatmentFocusRoute,
  OnelivUseTermsRoute,
  OnelivWelcomeRoute,
  SettingsAssistRoute.addChildren([
    SettingsAssistIndexRoute,
    SettingsAssistSecretaryDetailsAppointmentInfosRoute,
    SettingsAssistSecretaryDetailsFaqRoute,
    SettingsAssistSecretaryDetailsProfessionalInfosRoute,
    SettingsAssistSecretaryDetailsRestrictionsRoute,
    SettingsAssistAssistProAcceptanceIndexRoute,
    SettingsAssistCustomerAppointmentOverviewIndexRoute,
    SettingsAssistCustomerContactOverviewIndexRoute,
    SettingsAssistCustomerSiteOverviewIndexRoute,
    SettingsAssistFeatureSettingsIndexRoute,
    SettingsAssistFollowUpAppointmentReminderIndexRoute,
    SettingsAssistRescuedAppointmentOverviewIndexRoute,
    SettingsAssistSecretaryDetailsIndexRoute,
    SettingsAssistSubscribeAssistProLegacyIndexRoute,
    SettingsAssistSubscribeAssistProIndexRoute,
    SettingsAssistSubscribedAssistIndexRoute,
    SettingsAssistUnsubscribeAssistProIndexRoute,
    SettingsAssistUserTrackableLinksIndexRoute,
    SettingsAssistCustomerContactOverviewStoriesFeedIndexRoute,
    SettingsAssistFollowUpAppointmentReminderPatientsIndexRoute,
    SettingsAssistSubscribeAssistProConfirmIndexRoute,
    SettingsAssistUnsubscribeAssistProUpsertPhoneIndexRoute,
    SettingsAssistUserTrackableLinksUserTrackableLinkIdIndexRoute,
    SettingsAssistUserTrackableLinksCreateIndexRoute,
    SettingsAssistUserTrackableLinksUserTrackableLinkIdReportIndexRoute,
  ]),
  AccessBlockedIndexRoute,
  CalendarIndexRoute,
  GeneralTermsIndexRoute,
  HomeIndexRoute,
  PatientsIndexRoute,
  RecommendationIndexRoute,
  SettingsIndexRoute,
  UpdateRequiredIndexRoute,
  WaitingRoomIndexRoute,
  AppointmentAppointmentIdFlexiblePricingRoute,
  AppointmentAppointmentIdPatientSwapRoute,
  AppointmentAppointmentIdPatientSwapSearchRoute,
  AppointmentAppointmentIdRescheduleRoute,
  AppointmentAppointmentIdReschedulePatientRoute,
  AppointmentCreateAvailableOptionsRoute,
  AppointmentCreateFlexiblePricingRoute,
  AppointmentCreatePatientRoute,
  AppointmentCreateSearchPatientRoute,
  CalendarUnavailableSlotsCreateRoute,
  PatientsPatientIdUpdateRoute,
  SettingsBillingBillingItemIdRoute,
  SettingsBillingDetailsRoute,
  WaitingRoomFollowUpAppointmentReminderAppointmentIdRoute,
  AppointmentCreateIndexRoute,
  PatientsPatientIdIndexRoute,
  RecommendationConfirmationIndexRoute,
  SettingsBillingIndexRoute,
  SettingsCommunityIndexRoute,
  SettingsPaymentsIndexRoute,
  SettingsProfileIndexRoute,
  SettingsReferralIndexRoute,
  SettingsReservedSchedulesIndexRoute,
  SettingsScheduleOptionsIndexRoute,
  SettingsPaymentsBankAccountChangeBankAccountOrOwnershipRoute,
  SettingsPaymentsBankAccountUpdateRoute,
  SettingsPaymentsCreateConfirmationRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentAnticipationRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentDetailsRoute,
  SettingsPaymentsPatientPaymentsAboutPaymentsRoute,
  SettingsPaymentsPatientPaymentsDetailsRoute,
  SettingsPaymentsPatientPaymentsRefundRoute,
  SettingsPaymentsPatientPaymentsRefundReceiptRoute,
  SettingsPaymentsPayablesAboutRoute,
  SettingsProfileCardCreateRoute,
  SettingsReservedSchedulesReservedScheduleIdCancelRoute,
  SettingsReservedSchedulesCreateConfirmRoute,
  SettingsReservedSchedulesCreateSlotsRoute,
  SettingsReservedSchedulesCreateStartingDayRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsAppointmentReceivingOptionIdRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsCreateRoute,
  SettingsScheduleOptionsAppointmentTypesAppointmentTypeIdRoute,
  SettingsScheduleOptionsAppointmentTypesCreateRoute,
  SettingsScheduleOptionsSchedulesScheduleIdRoute,
  SettingsScheduleOptionsSchedulesCreateRoute,
  WaitingRoomFollowUpAppointmentReminderPatientPatientIdRoute,
  SettingsPaymentsBankAccountIndexRoute,
  SettingsPaymentsCreateIndexRoute,
  SettingsPaymentsEvolutionChartsIndexRoute,
  SettingsPaymentsPatientPaymentsIndexRoute,
  SettingsPaymentsPayablesIndexRoute,
  SettingsPaymentsTermsOfServiceIndexRoute,
  SettingsProfileCardIndexRoute,
  SettingsProfileChangePlanIndexRoute,
  SettingsProfileUpsertPublicPhoneIndexRoute,
  SettingsReservedSchedulesReservedScheduleIdIndexRoute,
  SettingsReservedSchedulesCreateIndexRoute,
  SettingsReservedSchedulesTermsOfUseIndexRoute,
  SettingsScheduleOptionsAppointmentReceivingOptionsIndexRoute,
  SettingsScheduleOptionsAppointmentTypesIndexRoute,
  SettingsScheduleOptionsSchedulesIndexRoute,
  WaitingRoomCodAgendamentoChangeTimeIndexRoute,
  WaitingRoomCodAgendamentoChoosePaymentChannelIndexRoute,
  WaitingRoomCodAgendamentoMenuIndexRoute,
  WaitingRoomCodAgendamentoReceiveRoomNowIndexRoute,
  WaitingRoomCodAgendamentoSendTotemPaymentIndexRoute,
  SettingsPaymentsPatientPaymentsGuidChangeOnlinePaymentStatusRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterOriginsRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterPaymentMethodsRoute,
  SettingsPaymentsPatientPaymentsFiltersFilterStatusRoute,
  SettingsReservedSchedulesReservedScheduleIdNextReserveIdCancelRoute,
  WaitingRoomCodAgendamentoChangeTimeConfirmIndexRoute,
]);

/* prettier-ignore-end */
